import * as THREE from 'three'
import React, { useEffect, useMemo, useState } from 'react'
import { useThree } from '@react-three/fiber'

import { const_var, params } from '../../../redux/reducers/reducer'
import { textureAnisotropy } from '../../../utils/Functions'
import { ReflectLegTextureNX, ReflectLegTextureNY, ReflectLegTextureNZ, ReflectLegTexturePX, ReflectLegTexturePY, ReflectLegTexturePZ, TrussRailTextureImg } from '../../../utils/Textures'

import FrontLean from './FrontLean'
import BackLean from './BackLean'
import LeftLean from './LeftLean'
import RightLean from './RightLean'
import { wallnameBySec } from '../../../redux/reducers/componentReducer'
import { updateDoorWindowsArray } from '../../../action'
import { useDispatch } from 'react-redux'
import { useTexture } from '@react-three/drei'

const LeanTo = () => {
    const dispatch = useDispatch();
    
    const { gl } = useThree();
    const [overlapTrussArr, setOverlapTrussArr] = useState(false);
    
    const texture = useTexture( process.env.REACT_APP_BASE_URL+TrussRailTextureImg);

    const isShowCenterBuilding = params.isShowCenter;


    const envMap = useMemo(() => {
        let envMap = const_var.envIMG
        textureAnisotropy(gl, envMap, 1, 1, 0)
        return envMap
    }, []);
    
    const normalMap = useMemo(() => {
        let normalMap = texture
        textureAnisotropy(gl, normalMap, 1, 1, Math.PI / 2)
        return normalMap
    }, []);

    useEffect(() => {
        if (const_var.newDoorsArray?.length > 0) {
            if (!params.add_front_lean) {
                const doorArrOnLean = const_var.newDoorsArray.filter((item, index) =>(wallnameBySec[item.userData.wallName] === 'frontlean'))
                if (doorArrOnLean.length > 0) {
                    const newDoorArrOnLean = const_var.newDoorsArray.filter((item, index) =>(wallnameBySec[item.userData.wallName] !== 'frontlean'))
                    dispatch(updateDoorWindowsArray(newDoorArrOnLean,true));
                }
            }
            if (!params.add_back_lean) {
                const doorArrOnLean = const_var.newDoorsArray.filter((item, index) =>(wallnameBySec[item.userData.wallName] === 'backlean'))
                if (doorArrOnLean.length > 0) {
                    const newDoorArrOnLean = const_var.newDoorsArray.filter((item, index) =>(wallnameBySec[item.userData.wallName] !== 'backlean'))
                    dispatch(updateDoorWindowsArray(newDoorArrOnLean,true));
                }
            }
            if (!params.add_left_lean) {
                const doorArrOnLean = const_var.newDoorsArray.filter((item, index) =>(wallnameBySec[item.userData.wallName] === 'leftlean'))
                if (doorArrOnLean.length > 0) {
                    const newDoorArrOnLean = const_var.newDoorsArray.filter((item, index) =>(wallnameBySec[item.userData.wallName] !== 'leftlean'))
                    dispatch(updateDoorWindowsArray(newDoorArrOnLean,true));
                }
            }
            if (!params.add_right_lean) {
                const doorArrOnLean = const_var.newDoorsArray.filter((item, index) =>(wallnameBySec[item.userData.wallName] === 'rightlean'))
                if (doorArrOnLean.length > 0) {
                    const newDoorArrOnLean = const_var.newDoorsArray.filter((item, index) =>(wallnameBySec[item.userData.wallName] !== 'rightlean'))
                    dispatch(updateDoorWindowsArray(newDoorArrOnLean,true));
                }
            }
        }
    }, [params.add_front_lean, params.add_back_lean, params.add_left_lean, params.add_right_lean])
    
    return !isShowCenterBuilding && (
        <>
            <FrontLean overlapTrussArr={overlapTrussArr} setOverlapTrussArr={setOverlapTrussArr} normalMap={normalMap} envMap={envMap} />
            <BackLean overlapTrussArr={overlapTrussArr} setOverlapTrussArr={setOverlapTrussArr} normalMap={normalMap} envMap={envMap} />
            <LeftLean overlapTrussArr={overlapTrussArr} setOverlapTrussArr={setOverlapTrussArr} normalMap={normalMap} envMap={envMap} />
            <RightLean overlapTrussArr={overlapTrussArr} setOverlapTrussArr={setOverlapTrussArr} normalMap={normalMap} envMap={envMap} />
        </>
    )
}

export default LeanTo